import { datadogLogs } from '@datadog/browser-logs';
import axios, { type AxiosResponse, CanceledError } from 'axios';

import getEnvironment from './environment';

export const DEFAULT_TIMEOUT = 10 * 1000;

const CAMEL_BASE = '/api/camel';

export const camelUrl = (camelPath: string): string => `${CAMEL_BASE}${camelPath}`;

export type ApiParams = Record<string, unknown>;

const REPEAT_LIST_PARAMS = { indexes: null } as const;

const responseSizeKb = (contentLength: string | undefined) => {
  if (!contentLength) return null;
  return Math.round((parseInt(contentLength, 10) / 1024) * 100) / 100;
};

const isInterceptorCanceledResponse = (response: Partial<AxiosResponse>): boolean =>
  !response.headers;

export const apiGet = async (
  apiPath: string,
  params?: ApiParams,
  timeoutMs?: number,
  signal?: AbortSignal,
): Promise<unknown> => {
  const startTime = performance.now();
  const response = await axios.get(apiPath, {
    timeout: timeoutMs ?? DEFAULT_TIMEOUT,
    params,
    paramsSerializer: REPEAT_LIST_PARAMS,
    signal,
  });

  if (isInterceptorCanceledResponse(response)) {
    throw new CanceledError(`request canceled by an axios interceptor: ${apiPath}`);
  }

  if (getEnvironment().isProd) {
    datadogLogs?.logger?.log('api_call_success', {
      api_path: apiPath,
      duration_sec: Math.round((performance.now() - startTime) / 1000),
      response_size_kb: responseSizeKb(response.headers['content-length']),
      params,
    });
  }

  return response.data;
};
